module.exports = __webpack_public_path__ + "img/pool-side.1d3dac83.jpg";